// SkyTracker @skytracker/web — display formatters for telemetry values.
const COMPASS = ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'];

export function fmtFt(ft: number | null): string {
  if (ft == null) return '—';
  const m = Math.round(ft * 0.3048);
  return `${ft.toLocaleString()} ft (${m.toLocaleString()} m)`;
}

export function fmtKt(kt: number | null): string {
  if (kt == null) return '—';
  const kmh = Math.round(kt * 1.852);
  return `${Math.round(kt)} kt (${kmh} km/h)`;
}

export function fmtFpm(fpm: number | null): string {
  if (fpm == null) return '—';
  const sign = fpm > 0 ? '+' : '';
  return `${sign}${Math.round(fpm).toLocaleString()} fpm`;
}

export function fmtHeading(deg: number | null): string {
  if (deg == null) return '—';
  const idx = Math.round(((deg % 360) + 360) % 360 / 22.5) % 16;
  return `${COMPASS[idx]} (${Math.round(deg)}°)`;
}

export function fmtCoord(c: number): string {
  return c.toFixed(6);
}
